// @ts-check
import { useMutation } from '@tanstack/react-query';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import api from 'modules/queries/api';
import useInvalidateAssets from 'modules/queries/invalidateQueries/useInvalidateAssets';

const usePrivateParentUpdate = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/storm/privateParent/index.raw').LWApiPublicStormPrivateParentUpdateParamsRawI} params */
			(params) => api.storm.privateParent.apiRaw.update(params),
		onSuccess: (data, params) => {
			invalidateAssets(params.uniq_id);
		},
		onError: snackbarError,
	});
};

export default usePrivateParentUpdate;
